import type { ModeOfTransportConfig } from '../../../domain/types/configs/company/ModeOfTransportConfig';

export const modeOfTransportConfig: ModeOfTransportConfig = {
  modeOfTransport: [
    {
      value: "AIR",
      label: "Air Transport"
    },
    {
      value: "ROA",
      label: "Land Transport"
    },
    {
      label: "Ocean Transport",
      value: "SEA"
    }
  ]
}; 